import React, { useRef, useEffect } from 'react';
import './JapanTopPage.css';

interface JapanTopPageProps {
  isVisible: boolean;
}

const JapanTopPage: React.FC<JapanTopPageProps> = ({ isVisible }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video && isVisible) {
      // セキュリティ対策: 自動再生設定
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      
      const playVideo = async () => {
        try {
          await video.play();
        } catch (error) {
          console.warn('動画の自動再生に失敗しました:', error);
        }
      };
      
      playVideo();
    }
  }, [isVisible]);

  return (
    <div className={`japan-top-container ${isVisible ? 'visible' : ''}`}>
      {/* 背景動画 */}
      <div className="video-background">
        <video
          ref={videoRef}
          className="background-video"
          muted
          loop
          playsInline
          preload="auto"
          onContextMenu={(e) => e.preventDefault()} // 右クリック禁止
        >
          <source src="/japan_tour.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay"></div>
      </div>

      {/* メインコンテンツ */}
      <div className="japan-content">
        <div className="japan-title-container">
          <h1 className="japan-title rainbow-text">JAPAN</h1>
        </div>
        
        {/* スクロールインジケーター */}
        <div className="scroll-indicator">
          <div className="scroll-arrow">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p className="scroll-text">Scroll to explore</p>
        </div>
      </div>
    </div>
  );
};

export default JapanTopPage;